import { render, staticRenderFns } from "./ModifyAccount.vue?vue&type=template&id=ae4bd87a&scoped=true"
import script from "./ModifyAccount.vue?vue&type=script&lang=js"
export * from "./ModifyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4bd87a",
  null
  
)

export default component.exports